"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var AutoCapture = /** @class */ (function () {
    function AutoCapture(autoStart) {
        if (autoStart === void 0) { autoStart = true; }
        this._started = false;
        this._statsigInstance = null;
        this._queuedEvents = [];
        this._maxQueueSize = 1000;
        this._startTime = Date.now();
        this._deepestScroll = 0;
        this._started = autoStart;
        this.initialize();
    }
    AutoCapture.prototype.addEventHandlers = function () {
        var _this = this;
        if (!document || !window) {
            return false;
        }
        var eventHandler = function (event) {
            _this.autoLogEvent(event || window.event);
        };
        this.registerEventHandler(document, 'click', eventHandler);
        this.registerEventHandler(document, 'submit', eventHandler);
        this.registerEventHandler(window, 'error', eventHandler);
        this.registerEventHandler(window, 'beforeunload', function () { return _this.pageUnloadHandler(); });
        this.registerEventHandler(window, 'scroll', function () { return _this.scrollEventHandler(); });
        return true;
    };
    AutoCapture.prototype.autoLogEvent = function (event) {
        var _a;
        var eventType = (_a = event.type) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (eventType === 'error' && event instanceof ErrorEvent) {
            this.logError(event);
            return;
        }
        var target = (0, utils_1.getTargetNode)(event);
        if (!target) {
            return;
        }
        if (!(0, utils_1.shouldLogEvent)(event, target)) {
            return;
        }
        if (eventType === 'submit') {
            eventType = 'form_submit';
        }
        var _b = (0, utils_1.gatherEventData)(target), value = _b.value, metadata = _b.metadata;
        this.queueAutoCapture(eventType, value, Object.fromEntries(metadata.entries()));
    };
    AutoCapture.prototype.flush = function () {
        var _this = this;
        if (!this._statsigInstance) {
            return;
        }
        this._queuedEvents.forEach(function (_a) {
            var _b;
            var eventName = _a[0], value = _a[1], metadata = _a[2];
            (_b = _this._statsigInstance) === null || _b === void 0 ? void 0 : _b.logEvent(eventName, value, metadata);
        });
        this._queuedEvents = [];
    };
    AutoCapture.prototype.initialize = function () {
        var _this = this;
        if (!document || !window || !document.addEventListener || !window.addEventListener) {
            return;
        }
        var docInitFunc = function () {
            _this.addEventHandlers();
            _this.logPageView();
        };
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', docInitFunc);
        }
        else {
            docInitFunc();
        }
        var windowLoadFunc = function () {
            _this.logPerformance();
        };
        if (document.readyState !== 'complete') {
            window.addEventListener('load', windowLoadFunc);
        }
        else {
            windowLoadFunc();
        }
    };
    AutoCapture.prototype.logError = function (event) {
        var error = (event === null || event === void 0 ? void 0 : event.error) || {};
        var errorStr = error;
        if (typeof error === 'object') {
            try {
                errorStr = JSON.stringify(error);
            }
            catch (e) {
                errorStr = error.toString();
            }
        }
        this.queueAutoCapture('error', event.message, {
            message: event.message,
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
            error_str: errorStr,
        });
    };
    AutoCapture.prototype.logPageView = function () {
        var _this = this;
        var func = function () {
            var url = (0, utils_1.getSafeUrl)();
            _this.queueAutoCapture('page_view', (0, utils_1.getSanitizedPageUrl)(), {
                title: document === null || document === void 0 ? void 0 : document.title,
                referrer: (document === null || document === void 0 ? void 0 : document.referrer) || '',
                queryParams: Object.fromEntries(url.searchParams),
            }, true);
        };
        setTimeout(func, 1);
    };
    AutoCapture.prototype.logPerformance = function () {
        var _this = this;
        if (!window || !window.performance) {
            return;
        }
        var func = function () {
            var _a, _b;
            if (typeof window.performance.getEntriesByType !== 'function' ||
                typeof window.performance.getEntriesByName !== 'function') {
                return;
            }
            var metadata = new Map();
            var navEntries = window.performance.getEntriesByType('navigation');
            if (navEntries && navEntries.length > 0) {
                var nav = navEntries[0];
                if (nav instanceof PerformanceNavigationTiming) {
                    metadata.set('load_time_ms', (_a = nav.duration) === null || _a === void 0 ? void 0 : _a.toFixed(2));
                    metadata.set('dom_interactive_time_ms', (nav.domInteractive - nav.startTime).toFixed(2));
                    metadata.set('redirect_count', nav.redirectCount);
                    metadata.set('transfer_bytes', nav.transferSize);
                }
            }
            var fpEntries = window.performance.getEntriesByName('first-contentful-paint');
            if (fpEntries && fpEntries.length > 0) {
                var fp = fpEntries[0];
                if (fp instanceof PerformancePaintTiming) {
                    metadata.set('first_contentful_paint_time_ms', (_b = fp.startTime) === null || _b === void 0 ? void 0 : _b.toFixed(2));
                }
            }
            _this.queueAutoCapture('performance', (0, utils_1.getSanitizedPageUrl)(), __assign({}, Object.fromEntries(metadata.entries())));
        };
        setTimeout(func, 1);
    };
    AutoCapture.prototype.pageUnloadHandler = function () {
        this.queueAutoCapture('page_view_end', (0, utils_1.getSanitizedPageUrl)(), {
            scrollDepth: this._deepestScroll,
            pageViewLength: Date.now() - this._startTime,
        }, true);
    };
    AutoCapture.prototype.queueAutoCapture = function (name, value, metadata, immediate) {
        var _a;
        if (immediate === void 0) { immediate = false; }
        var href = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) || '';
        this.queue("auto_capture::".concat(name), value, __assign({ sessionID: (0, utils_1.getSessionId)(), page_url: href }, metadata), immediate);
    };
    AutoCapture.prototype.queue = function (eventName, value, metadata, immediate) {
        var _a, _b;
        if (immediate === void 0) { immediate = false; }
        (0, utils_1.debugLog)("Queuing: ".concat(eventName, ", ").concat(value, ", ").concat(JSON.stringify(metadata, null, 2)));
        var shouldQueue = !this._started || !this._statsigInstance;
        if (shouldQueue) {
            if (this._queuedEvents.length < this._maxQueueSize) {
                this._queuedEvents.push([eventName, value, metadata]);
            }
        }
        else {
            if (this._queuedEvents.length > 0) {
                this.flush();
            }
            (_a = this._statsigInstance) === null || _a === void 0 ? void 0 : _a.logEvent(eventName, value, metadata);
            if (immediate) {
                (_b = this._statsigInstance) === null || _b === void 0 ? void 0 : _b.flushEvents();
            }
        }
    };
    AutoCapture.prototype.registerEventHandler = function (element, eventType, handler) {
        if (!element || !element.addEventListener) {
            return;
        }
        element.addEventListener(eventType, handler, true);
    };
    AutoCapture.prototype.scrollEventHandler = function () {
        var _a;
        var scrollHeight = ((_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 1;
        this._deepestScroll = Math.max(this._deepestScroll, Math.min(100, Math.round((window.scrollY + window.innerHeight) / scrollHeight * 100)));
    };
    AutoCapture.prototype.setStatsigInstance = function (statsigInstance) {
        this._statsigInstance = statsigInstance;
    };
    AutoCapture.prototype.start = function () {
        this._started = true;
        this.flush();
    };
    AutoCapture.prototype.stop = function () {
        this._started = false;
    };
    return AutoCapture;
}());
exports.default = AutoCapture;
